import React, { useEffect } from 'react';
import GraphicUtils from "../../../../../../utils/graphic-utils.js";
import ReportUtils from "../../../../../../utils/report-utils.js";
import {translate} from "../../../../../../components/translate/translate.jsx";

const ActionsHistoryContent = ({ data, boName }) => {

    useEffect(() => {
        const list = data.actions_history ?? [];

        const formatMonthYear = (date) => {
            const [month, year] = date.split('/');
            return `${translate(month).slice(0, 3)}/${year}`;
        };

        const values = [...new Set(
            list
                .sort((a, b) => a.sort.localeCompare(b.sort))
                .map(item => formatMonthYear(item.date))
        )];

        const actions = [...new Set(
            list.map(item =>
                item.action === 'BO GCM' ? boName : item.action
            )
        )];

        const actionMap = new Map(
            actions.map(action => [action, {}])
        );

        list.forEach(item => {
            const action = item.action === 'BO GCM' ? boName : item.action;

            actionMap.get(action)[formatMonthYear(item.date)] = item.total;
        });

        const dataColumns = actions.map(action => [
            action,
            ...values.map(date =>
                actionMap.get(action)[date] || 0
            )
        ]);

        GraphicUtils.lineChart("actions-history-chart", dataColumns, values);
        ReportUtils.createExportableTable(["Ação", ...values], dataColumns, "Histórico de ações");

    }, [data, boName]);

    return (
        <>
            <div className="chart-report">
                <span className="chart-title">Histórico de ações</span>
                <div className="mt-3" id="actions-history-chart"/>
            </div>

            <div className="chart-divisor"/>
        </>
    );
};

export default ActionsHistoryContent;